var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUlDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 259 246",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7652,-3618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-9",
    serifId: "Page 9",
    transform: "matrix(1,0,0,1,6750,2250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer-2",
    serifId: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,639.84,1288.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L192.119,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(49,57,65)",
      strokeWidth: 18
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,639.84,1648.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L192.119,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(242,242,247)",
      strokeWidth: 18
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.97394,375.329)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,964.106,1032.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L181.441,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(242,242,247)",
      strokeWidth: 24
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,963.88,1119.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L181.441,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(242,242,247)",
      strokeWidth: 24
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,964.633,1212.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L181.441,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(242,242,247)",
      strokeWidth: 24
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-49.6513)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,929.383,1067.08)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.32,-15.32C-23.781,-15.32 -30.639,-8.462 -30.639,-0.001C-30.639,8.459 -23.781,15.32 -15.32,15.32C-6.859,15.32 -0.001,8.459 -0.001,-0.001C-0.001,-8.462 -6.859,-15.32 -15.32,-15.32",
    style: {
      fill: "rgb(242,242,247)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,929.383,1067.08)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -15.32,
    cy: 0,
    rx: 15.319,
    ry: 15.32,
    style: {
      fill: "none",
      stroke: "rgb(242,242,247)",
      strokeWidth: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-23.6152)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,929.383,1128.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.32,-15.32C-23.781,-15.32 -30.639,-8.462 -30.639,-0.001C-30.639,8.459 -23.781,15.32 -15.32,15.32C-6.86,15.32 -0.001,8.459 -0.001,-0.001C-0.001,-8.462 -6.86,-15.32 -15.32,-15.32",
    style: {
      fill: "rgb(242,242,247)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,929.383,1128.36)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -15.32,
    cy: 0,
    rx: 15.319,
    ry: 15.32,
    style: {
      fill: "none",
      stroke: "rgb(242,242,247)",
      strokeWidth: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,1.96174)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,929.383,1195.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.32,-15.32C-23.781,-15.32 -30.639,-8.462 -30.639,-0.001C-30.639,8.459 -23.781,15.32 -15.32,15.32C-6.86,15.32 -0.001,8.459 -0.001,-0.001C-0.001,-8.462 -6.86,-15.32 -15.32,-15.32",
    style: {
      fill: "rgb(242,242,247)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,929.383,1195.77)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -15.32,
    cy: 0,
    rx: 15.319,
    ry: 15.32,
    style: {
      fill: "none",
      stroke: "rgb(242,242,247)",
      strokeWidth: 1
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1251.75,1431.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L181.441,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(242,242,247)",
      strokeWidth: 18
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1251.75,1495.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L181.441,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(242,242,247)",
      strokeWidth: 18
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1251.75,1562.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L181.441,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(242,242,247)",
      strokeWidth: 18
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUlDark);
export default __webpack_public_path__ + "static/media/ul_dark.a3c538a2a8a861af3ed970606f262e88.svg";
export { ForwardRef as ReactComponent };